<app-header [pageName]="pageName"></app-header>

<div class="register">
    <div class="row main-row">
        <div class="col-md-3 register-left">
            <img src="../../assets/images/logo_white.png" alt="" />
            <h3>Welcome</h3>
            <p>Weclome to GaniSponsor Market Property Registration</p>
            <!-- <input (click)="onShowLogin()" type="submit" name="" value="Login"/><br/> -->
        </div>

        <div class="col-md-9 register-right">
            <!-- <ul class="nav nav-tabs nav-justified" id="navTab">
                            <li class="nav-item">
                                <a (click)="onShowOwner()" style="cursor: pointer;" id='active' class="nav-link active">Owners</a>
                            </li>
                            <li class="nav-item">
                                <a (click)="onShowClient()" style="cursor: pointer;" id ="inactive" class="nav-link reactive">Sponsors</a>
                            </li>
                            
                        </ul> -->

            <div class="tab-content">

                <form class="form-signin" [formGroup]="ownerRegisterForm">
                    <div *ngIf="visible">
                        <h3 class="register-heading">Add Your Property</h3><br>


                        <div class="row register-form">
                            <div class="col-md-6">
                                <!-- Event Name -->
                                <div class="form-group">
                                    <input formControlName="name" type="text" class="form-control"
                                        placeholder="Enter Property (e.g: Event, Individual) Name " value="" />
                                </div>

                               

                                <!-- Event Description-->
                                <div class="form-group">
                                    <textarea formControlName="description" class="form-control" id="desc"
                                        placeholder="Enter Property Description"></textarea>
                                </div>

                                <div class="form-group">
                                    <input formControlName="industry" type="text" class="form-control"
                                        placeholder="Industry" value="" />
                                </div>

                                <div class="row">
                                    <div class="col-md-4">
                                        <!-- Event Number of Sponsor -->
                                        <div class="form-group">
                                            <input type="number" (change)="onChangeTierNumber()"
                                                formControlName="sponsor_number" class="form-control" id="sp_numb"
                                                placeholder="No of sponsor required" min="1" max="4" value="">
                                        </div>
                                        <!-- <div class="form-group">
                                            <select formControlName="sp_number" class="form-control">
                                                <option value="" >No of Sponsors</option> 
                                                <option [ngValue]="sp_number" *ngFor="let sp_number of sp_numbers">{{ sp_number }}
                                                </option>
                                            </select>
                                        </div> -->
                                    </div>

                                    <div class="col-md-8">
                                        <!-- Enter Sponsor Fees -->

                                        <!-- Tier One -->
                                        <span *ngIf="isTierOne">
                                            <div class="form-group">
                                                <input formControlName="m_value1" type="text" class="form-control"
                                                    placeholder="Enter Tier 1 Sponsorship Fees" value="" />
                                            </div>
                                        </span>

                                        <!-- Tier Two -->
                                        <span *ngIf="isTierTwo">
                                            <div class="form-group">
                                                <input formControlName="m_value1" type="text" class="form-control"
                                                    placeholder="Enter Tier 1 Sponsorship Fees" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="m_value2" type="text" class="form-control"
                                                    placeholder="Enter Tier 2 Sponsorship Fees" value="" />
                                            </div>
                                        </span>

                                        <!-- Tier Three-->
                                        <span *ngIf="isTierThree">
                                            <div class="form-group">
                                                <input formControlName="m_value1" type="text" class="form-control"
                                                    placeholder="Enter Tier 1 Sponsorship Fees" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="m_value2" type="text" class="form-control"
                                                    placeholder="Enter Tier 2 Sponsorship Fees" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="m_value3" type="text" class="form-control"
                                                    placeholder="Enter Tier 3 Sponsorship Fees" value="" />
                                            </div>
                                        </span>

                                        <!-- Tier Four -->
                                        <span *ngIf="isTierFour">
                                            <div class="form-group">
                                                <input formControlName="m_value1" type="text" class="form-control"
                                                    placeholder="Enter Tier 1 Sponsorship Fees" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="m_value2" type="text" class="form-control"
                                                    placeholder="Enter Tier 2 Sponsorship Fees" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="m_value3" type="text" class="form-control"
                                                    placeholder="Enter Tier 3 Sponsorship Fees" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="m_value4" type="text" class="form-control"
                                                    placeholder="Enter Tier 4 Sponsorship Fees" value="" />
                                            </div>
                                        </span>

                                    </div>
                                </div>

                                <!-- enter Current Sponsor -->
                                <div class="form-group">
                                    <input formControlName="sp_name" type="text" class="form-control"
                                        placeholder="Enter Current Sponsor/s" value="" />
                                </div>

                                <!-- Enter Attendance No -->
                                <div class="form-group">
                                    <input formControlName="attendance" type="text" class="form-control"
                                        placeholder="Enter Attendance/Reach No" value="" />
                                </div><br>

                                <!-- Select type of sponsors -->
                                <div class="form-group Wrapper">
                                    <h4>Select Type of Sponsors (Tiers) : </h4><br>
                                    <div class="row">

                                        <div class="col-md-6">
                                            <div class="form-groups">
                                                <input type="checkbox" formControlName="sp_financial" id="financial"
                                                    name="sponsors" value="Financial Sponsors"
                                                    class="custom-control-input">
                                                <label for="financial"
                                                    class="custom-form-control">{{sponsor_financial}}</label>
                                            </div>
                                            <div class="form-groups">
                                                <input type="checkbox" formControlName="sp_media" id="media"
                                                    name="sponsors" value="Media Sponsors">
                                                <label for="media">{{sponsor_media}}</label>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-groups">
                                                <input type="checkbox" formControlName="sp_inKind" id="in_kind"
                                                    name="sponsors" value="In-Kind Sponsors">
                                                <label for="in_kind">{{sponsor_inKind}}</label>
                                            </div>
                                            <div class="form-groups">
                                                <input type="checkbox" formControlName="sp_promotional" id="promotional"
                                                    name="sponsors" value="Promotional Sponsors">
                                                <label for="promotional">{{sponsor_promotional}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Enter Property Website -->
                                <div class="form-group">
                                    <input formControlName="website" type="text" class="form-control"
                                        placeholder="Enter Property Website" value="" />
                                </div>
                                <!-- Enter Contact email -->
                                <div class="form-group">
                                    <input formControlName="email" type="email" class="form-control"
                                        placeholder="Enter Email" value="" />
                                </div>

                                <!-- Enter Contact Number -->
                                <div class="form-group">
                                    <input formControlName="contact" type="text" name="txtEmpPhone" class="form-control"
                                        placeholder="Enter Contact Number" value="" />
                                </div>
                                <!-- Image url upload -->
                                <div class="form-group">
                                    <label class="custom-file-upload">
                                        <input type="file" (change)="selectFile($event)" formControlName="image_url" id="file" class="file" value="">
                                        Choose Logo
                                    </label>
                                    <p id="filename">{{ filename }}</p>

                                </div>


                                <!-- <button class="btn btn-success" (click)="upload()">Upload
                                    logo</button><br><br> -->


                            </div>
                            <div class="col-md-6">
                                <!-- Enter Country (Dropdown list with South Africa as the sole option) -->
                                <!-- <div class="form-group">
                                    <input formControlName="market" type="text" class="form-control"
                                        placeholder="Enter Market" value="" />
                                </div> -->

                                <!-- Enter category -->
                                <div class="form-group Wrapper">
                                    <h4>Select Type (Multiple Selection Possible): </h4><br>
                                    <div class="row">

                                        <div class="col-md-4 category-cols">
                                            <div class="form-groups">
                                                <input type="checkbox" id="art" name="type" value="Art">
                                                <label for="art" class="custom-form-control">Art</label>
                                            </div>
                                            <div class="form-groups">
                                                <input type="checkbox" id="music" name="type" value="Music">
                                                <label for="music">Music</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="sport" name="type" value="Sport">
                                                <label for="sport">Sport</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="conference" name="type"
                                                    value="Conference & Seminars">
                                                <label for="conference">Conference & Seminars</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="food" name="type" value="Food & Lifestyle">
                                                <label for="food">Food & Lifestyle</label>
                                            </div>
                                        </div>

                                        <div class="col-md-4 category-cols">
                                            <div class="form-groups">
                                                <input type="checkbox" id="festival" name="type" value="Festival">
                                                <label for="festival">Festival</label>
                                            </div>
                                            <div class="form-groups">
                                                <input type="checkbox" id="expo" name="type" value="Expo">
                                                <label for="expo">Expo</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="bespoke" name="type" value="Bespoke Event">
                                                <label for="bespoke">Bespoke Event</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="award" name="type" value="Award">
                                                <label for="award">Award</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="culture" name="type" value="Culture">
                                                <label for="culture">Culture</label>
                                            </div>

                                        </div>

                                        <div class="col-md-4 category-cols">

                                            <div class="form-groups">
                                                <input type="checkbox" id="nature" name="type"
                                                    value="Nature & Wildlife">
                                                <label for="nature">Nature & Wildlife</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="broadcast" name="type" value="Broadcast">
                                                <label for="broadcast">Broadcast</label>
                                            </div>
                                            <div class="form-groups">
                                                <input type="checkbox" id="type" name="type" value="Individual">
                                                <label for="individual">Individual</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="careers" name="type" value="Careers">
                                                <label for="careers">Careers</label>
                                            </div>

                                            <div class="form-groups">
                                                <input type="checkbox" id="youth" name="type" value="Youth Focused">
                                                <label for="youth">Youth Focused</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="form-group">
                                    <select formControlName="category" class="form-control">
                                        <option value="" selected disabled>Please select Category type</option>
                                        <option [ngValue]="category" *ngFor="let category of categories">{{ category }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Please select Country -->
                                <div class="form-group">
                                    <select formControlName="country" class="form-control">
                                        <option value="" selected>Please select Property Country</option>
                                        <option [ngValue]="country" *ngFor="let country of countries">{{ country }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Please Select Province -->
                                <div class="form-group">
                                    <select formControlName="location" class="form-control">
                                        <option value="">Please select Property Province</option>
                                        <option [ngValue]="location" *ngFor="let location of locations">{{ location }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Enter City -->
                                <div class="form-group">
                                    <input formControlName="city" type="text" class="form-control"
                                        placeholder="Enter City/Town" value="" />
                                </div>

                                <!-- <div class="form-group">
                                    <input formControlName="amount" type="text" class="form-control"
                                        placeholder="Rights Fees" value="" />
                                </div> -->

                                <!-- Enter Duration (In No of days) -->
                                <div class="form-group">
                                    <input formControlName="duration" type="text" class="form-control"
                                        placeholder="Enter Property Duration (In No of days)" value="" />
                                </div>
                                <div class="row">

                                    <div class="col-md-6">
                                        <label>Start Date: </label> &nbsp;&nbsp;
                                        <!-- <input type="date" id="start" name="trip-start" value="2018-07-22"
                                            min="2018-01-01" max="2018-12-31"> -->
                                        <input type="date" formControlName="start" class="form-control"
                                            data-date-inline-picker="true" />
                                    </div>

                                    <div class="col-md-6">
                                        <label>End Date: </label> &nbsp;&nbsp;
                                        <!-- <input type="date" id="end" name="trip-end" value="2018-07-22"
                                            min="2018-01-01" max="2018-12-31"> -->
                                        <input type="date" formControlName="end" class="form-control"
                                            data-date-inline-picker="true" />
                                    </div>
                                </div><br>

                                <!-- Enter Year -->
                                <div class="form-group">
                                    <input formControlName="period" type="text" class="form-control"
                                        placeholder="Enter Property Year/Years" value="" />
                                </div>

                                <!-- Enter Month -->
                                <div class="form-group">
                                    <select formControlName="date" class="form-control">
                                        <option value="">Please select Month</option>
                                        <option [ngValue]="month" *ngFor="let month of months">{{ month }}</option>

                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>Upload Proposal</label>
                                    <label class="custom-file-upload">
                                        <input type="file" (change)="selectProposalFiles($event)" id="file" formControlName="proposal_url" value=""
                                            class="file">
                                        Choose File
                                    </label>
                                    <p id="filename">{{ proposalFileName }}</p>

                                </div>

                                <div class="row d-flex justify-content-center" *ngIf="isLoading">
                                    <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
                                </div>

                                <!-- <input (click)="addEvent()" class="btnRegister" value="Add" /> -->
                                <button  (click)="addEvent()" style="width: 50%;" class="btn btn-success">Submit</button>
                            </div>
                            <div class="alert alert-success" role="alert" *ngIf="displaySuccessMessage"
                                style="margin: 10px;">
                                {{ successMessage }}
                            </div>
                            <div class="alert alert-dange" role="alert" *ngIf="displayErrorMessage"
                                style="margin: 10px;">
                                {{ errorMessage }}
                            </div>

                        </div>
                    </div>
                </form>

                <!-- Client Form -->

                <!-- <form class="form-signin" [formGroup]="sponsorRegisterForm">
                                <div *ngIf="clientVisible">
                                    <h3  class="register-heading">Register as Sponsor</h3>
                                    <div class="row register-form">
                                        <div class="col-md-6">
                                           

                                            <div class="form-group">
                                                <input formControlName="sp_name" type="text" class="form-control" placeholder="Name *" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="sp_industry" type="text" class="form-control" placeholder="Industry *" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="sp_period" type="text" class="form-control" placeholder="Duration *" value="" />
                                            </div>
                                            <div class="form-group">
                                                <input formControlName="email" type="email" class="form-control" placeholder="Email *" value="" />
                                            </div>

                                            <div class="form-group">
                                                <textarea fromControlName="description" class="form-control" id="descript" placeholder="Enter Description"></textarea>
                                            </div>
                                           
                                            <div class="form-group">
                                                <label class="btn btn-normal">
                                                    <input type="file" (change)="selectFile($event)" id="file" class="file">
                                                </label>
                                            </div>
                                            
                                              
                                              <button class="btn btn-success" [disabled]="!selectedFiles" (click)="upload()">Upload logo</button><br><br>
    
                                        </div>
                                        
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input formControlName="contact" type="text" maxlength="10" minlength="10" class="form-control" placeholder="Contact *" value="" />
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="marketValue" type="text" maxlength="10" minlength="10" class="form-control" placeholder="Market Value *" value="" />
                                            </div>
       
                                            <div class="form-group">
                                                <input formControlName="market" type="text" class="form-control" placeholder="Market *" value="" />
                                            </div>

                                            <div class="form-group">
                                                <select  formControlName="category" class="form-control" >
                                                    <option class="hidden"  selected disabled>Please select type</option>
                                                    <option [ngValue]="category" *ngFor="let category of categories">{{ category }}</option>
                                                </select>
                                            </div>

                                            <div class="form-group">
                                                <input formControlName="sp_region" type="text" class="form-control" placeholder="Country *" value="" />
                                            </div>
                                            <div class="form-group">
                                                <input formControlName="sp_province" type="text" class="form-control" placeholder="Province *" value="" />
                                            </div>
                                            <input (click)="addSponsor()" class="btnRegister"  value="Apply"/>
                                        </div>
                                    </div>
                                </div>
                            </form> -->

                <!-- <form class="form-signin" [formGroup]="loginForm">
                                <div *ngIf="loginVisible">
                                    <h3  class="register-heading">Login</h3>
                                    <div class="row register-form">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input formControlName="name" type="text" class="form-control" placeholder="Username" value="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input formControlName="password" type="password" class="form-control" placeholder="Password" value="" />
                                            </div>
                                            <input type="submit" class="btnRegister"  value="Login"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="alert alert-success" role="alert" *ngIf="successMessage"
                                style="background-color: aqua; margin-left: 10%">
                                    {{ successMessage }}
                            </div>
                            <div class="alert alert-dange" role="alert" *ngIf="errorMessage"
                                style="background-color:brown; margin-left: 10%;">
                                    {{ errorMessage }}
                            </div>
                            </form> -->

            </div>
        </div>
    </div>

</div>